import { setToken } from '../util/set-token';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitLsRemoteAction extends WorkerAction {
  type: GitAction.LsRemote;
  params: { branch?: string; authToken: string };
}

export class GitLsRemoteActionError extends WorkerActionError {}

export async function GitLsRemoteActionFn({ lg, params }: WorkerFnParams<GitLsRemoteAction>): Promise<string | null> {
  try {
    setToken(params.authToken);
    const branch = params.branch ? `refs/heads/${params.branch}` : 'HEAD';
    const output = lg.callAndCaptureOutput(['ls-remote', 'origin']);
    // 4c469f335ee60e5e7fa7f35989cf95b975a0a439	HEAD
    // dd46e084903103abaa5d94ca0b48ff7ac9d86181	refs/heads/adsadsasd
    // ...
    type CommitSHA = string;
    type Branch = string;
    const latestCommitPerBranch = output.split('\n').map((line) => line.split('\t')) as Array<[CommitSHA, Branch]>;
    const [latestCommit] = latestCommitPerBranch.find(([_, remoteBranch]) => remoteBranch === branch) || [null];

    return typeof latestCommit === 'string' ? latestCommit.trim() : null;
  } catch (err) {
    throw new GitLsRemoteActionError(err);
  }
}
